import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { Floor } from "../../objects/Floor";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { OxxoTopicthree } from "../../objects/Tema1/subtopicthree/OxxoTopicthree";
import { tabletPlanograma } from "../../objects/Tema1/subtopicthree/tabletPlanograma";
import { PointsActvOne } from "../../objects/Tema1/subtopicthree/PointsActv1";
import { Monitor } from "../../objects/Tema1/subtopicthree/Monitor";
import { audiosAssets } from "../../../../assets/audio";
import { ButtonScreenPoint } from "../../objects/ButtonScreenPoint";
// import { HelperLitght } from "../../../componets3D/HelperLitght";

// const _PI_2 = Math.PI / 2;
// const _euler = new Euler(0, 0, 0, "YXZ");
export class SceneTopicThree extends Scene {
	constructor(loadingManager, container, render, characted = new CharcterOxxo(), environmentToScenes) {
		super();
		this.characterSelected = characted;
		this.environment = environmentToScenes;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.correctpoints = 0;
		this.productsColoqued = 0;
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListenners();

		this.clickScreen = 0
	}
	create() {
		this.add(this.characterSelected);

		this.pointsactivity = new PointsActvOne();
		this.add(this.pointsactivity);
		this.oxxo = new OxxoTopicthree(this.loadingManager);
		this.add(this.oxxo);

		this.tablet = new tabletPlanograma();
		this.add(this.tablet);

		this.floor = new Floor(this.loadingManager);
		this.add(this.floor);

		this.monitorTwo = new Monitor(this.loadingManager);
		// this.add(this.monitorTwo);

		this.buttonPointerScreen = new ButtonScreenPoint(this.loadingManager)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	observerListenners() {
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.restartactivity, () => {
			this.oxxo.defaultPosition();
			this.pointsactivity.defaultStatus();
			this.mouseEvents.objectsToValue = [...this.pointsactivity.getobjectsInteractions(), ...this.oxxo.getobjectsInteractions()];
			this.correctpoints = 0;
			this.productsColoqued = 0;
			ObserverEmitter.emit(EVENTS.subtopicThree.activityTwo.countProductAct, this.productsColoqued);
		});
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.moveMonitor, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.2419, 0.0404, 0.3069), 1, new Vector3(-11.248, 0.028, 1.339), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				// this.camera.control.maxAzimuthAngle = -0.86;
				// this.camera.control.minAzimuthAngle = -2;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enableZoom = false
				this.camera.control.enableRotate = false;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicThree.activityone.moveFride, () => {
			this.tablet.visible = false;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-5.1486, -0.522, -8.5864), 1, new Vector3(-5.424, -1.482, -10.378), () => {
				this.mouseEvents.objectsToValue = [...this.pointsactivity.getobjectsInteractions(), ...this.oxxo.getobjectsInteractions()];
				this.mouseListenersActivityOne();
				this.characterSelected.visible = false;
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.447;
				this.camera.control.minAzimuthAngle = -0.295;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicThree.activityTwo.validateResponse, () => {
			if (this.productsColoqued >= 7) {
				ObserverEmitter.emit(EVENTS.subtopicThree.activityone.finishcoloqued, this.correctpoints);
			}
		});

		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.hidden, () => {
			this.monitorTwo.initMonitor()
			this.remove(this.monitorTwo)
			this.oxxo.Pantallas_1.visible = true;
		});

		ObserverEmitter.on(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, (screen = 0) => {
			this.moveScreenButton(screen)
		});
	}

	moveScreenButton(screen = 0) {
		this.buttonPointerScreen.visible = true
		switch (screen) {
			case 1:
				this.buttonPointerScreen.scale.set(0.0339, 0.0339, 0.0339)
				this.buttonPointerScreen.position.set(-10.9798, -0.1511, 0.9115)
				this.buttonPointerScreen.rotation.y = -2.7496
				this.buttonPointerScreen.onAnimationOpacity()
				this.clickScreen = 1
				break;
			case 2:
				this.buttonPointerScreen.position.set(-11.1782, 0.1252, 0.9115)
				this.clickScreen = 2
				break;
			case 3:
				this.buttonPointerScreen.position.set(-11.3653, 0.0561, 0.9115)
				this.clickScreen = 3
				break;
			case 4:
				this.buttonPointerScreen.position.set(-11.0794, 0.138, 0.9115)
				this.clickScreen = 4
				break;
			case 5:
				this.buttonPointerScreen.position.set(-11.3785, -0.0167, 0.9115)
				this.clickScreen = 5
				break;
			default:
				this.buttonPointerScreen.visible = false
				this.buttonPointerScreen.clearAnimation()
				this.mouseEvents.disposeInteractions();
				this.clickScreen = 0
				break;
		}
	}

	initGameViews() {
		this.camera.moveCameraToPoint(new Vector3(-8.0946, -1.3089, -2.4731), 1, new Vector3(-7.318, -1.432, -3.142), () => {
			this.characterSelected.visible = true;
			this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
			this.camera.control.minPolarAngle = MathUtils.degToRad(20);
			this.camera.control.enableRotate = false;
			this.camera.control.maxAzimuthAngle = -0.86;
			this.camera.control.minAzimuthAngle = -2;
			this.camera.control.minDistance = 1;
			this.camera.control.maxDistance = 3;
			this.camera.control.enablePan = false;

			this.characterSelected.position.set(-7.1587, -1.7904, -3.3984);
			this.characterSelected.rotation.y = -0.8026;

			this.tablet.position.set(-7.2637, -1.3087, -2.7482);
			this.tablet.rotation.set(1.5512, 0, 1.3307);
			this.tablet.visible = true

			this.correctpoints = 0;
			this.productsColoqued = 0;

			this.oxxo.positionProudctSet()
			this.pointsactivity.positionAll()

			this.activeAudio()
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.characterSelected.visible = false;
					this.activeAudio()
				});
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimateSaludo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.set(0, -1.5145, 0);

					this.monitorTwo.position.set(-11.1223, -0.2004, 1.2406);
					this.monitorTwo.initMonitor()

					// this.monitorTwo.helpers();
					// this.monitorTwo.helpersChild();

					this.oxxo.Pantallas_1.visible = false;
					this.add(this.monitorTwo);

					this.buttonPointerScreen.visible = false
					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [
						this.buttonPointerScreen,
					];
					this.mouseListenersScreen()
					this.add(this.buttonPointerScreen)
					this.activeAudio()

				});
				break;
			case 2:
				this.initGameViews();
				break;

			default:
				this.camera.moveCameraToPoint(new Vector3(-12.9534, 0.0394, -3.0325), 1, new Vector3(-10.974, -0.272, -4.252), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		// new HelperLitght("Ambiente dentro", this.ambient);
		this.add(this.ambient);
	}

	mouseListenersScreen() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				if (["CircleLittle", "CircleBig"].includes(name)) {
					ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.listerClickScreen, this.clickScreen)
					switch (this.clickScreen) {
						case 1:
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img2, 2);
							this.moveScreenButton(2)
							break;
						case 2:
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img3, 2);
							this.moveScreenButton(3)
							break;
						case 3:
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img4, 2);
							this.moveScreenButton(4)
							break;
						case 4:
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img5, 2);
							this.moveScreenButton(5)
							break;
						case 5:
							this.moveScreenButton(6)
							break;
						default:
							break;
					}
				}
			}
		})
	}

	// 1 brak (-0.956,1.278,-0.342) (-0.956,1.278,-0.260) (-0.956,1.278,-0.183)
	// 2 lalaplat  {x:-0.839,y:1.293,z:-0.342}, {x:-0.839,y:1.293,z:-0.260}, {x:-0.839,y:1.293,z:-0.182}
	// 3 lalafresa  {x:-0.781,y:1.293,z:-0.342}, {x:-0.781,y:1.293,z:-0.260},  {x:-0.781,y:1.293,z:-0.182}
	// 4 nuez {x:-0.720,y:1.293,z:-0.342}, {x:-0.720,y:1.293,z:-0.260}, {x:-0.720,y:1.293,z:-0.182}
	// 5 platano {x:-0.411,y:1.306,z:-0.342}, {x:-0.411,y:1.306,z:-0.260}, {x:-0.411,y:1.306,z:-0.182}
	// 6 activia {x:-1.008,y:1.007,z:-0.342}, {x:-1.008,y:1.007,z:-0.261}, {x:-1.008,y:1.007,z:-0.183}
	// 7 danone {x:-0.901,y:1.027,z:-0.342}, {x:-0.901,y:1.027,z:-0.261}, {x:-0.901,y:1.027,z:-0.183}

	evaluatePoints(productCliked, positionName) {
		if (positionName === "circle_yogbreak" && productCliked.name.includes("Break")) {
			this.correctpoints++;
		}
		if (positionName === "circle_yoglalafre_pla" && productCliked.name.includes("Lala_1")) {
			this.correctpoints++;
		}
		if (positionName === "circle_lalafresa" && productCliked.name.includes("Lala_2")) {
			this.correctpoints++;
		}
		if (positionName === "circle_yoplaitnuezfresa" && productCliked.name.includes("Yoplait_3")) {
			this.correctpoints++;
		}
		if (positionName === "circle_licuadofresaplatano" && productCliked.name.includes("Danone_4")) {
			this.correctpoints++;
		}
		if (positionName === "circle_activia_ciruela" && productCliked.name.includes("Activia_2")) {
			this.correctpoints++;
		}
		if (positionName === "circle_danonefresa" && productCliked.name.includes("Danone_1")) {
			this.correctpoints++;
		}
		this.productsColoqued++;

		ObserverEmitter.emit(EVENTS.subtopicThree.activityTwo.countProductAct, this.productsColoqued);
		if (this.productsColoqued >= 7) {
			// this.camera.moveCameraToPoint(new Vector3(-6.1539, 0.661, -7.7207), 1, new Vector3(-6.32, -1.603, -10.208), () => {});
			// ObserverEmitter.emit(EVENTS.subtopicThree.activityone.finishcoloqued, this.correctpoints);
		}
	}

	onRemoveForClicked(product) {
		switch (product.name) {
			case "Break1":
			case "Break1001":
			case "Break1002":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Break1.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Break1001.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Break1002.name);
				break;
			case "Yoplait_3":
			case "Yoplait_3001":
			case "Yoplait_3002":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Yoplait_3.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Yoplait_3001.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Yoplait_3002.name);
				break;
			case "Lala_2":
			case "Lala_2001":
			case "Lala_2002":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_2.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_2001.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_2002.name);
				break;
			case "Lala_1":
			case "Lala_1001":
			case "Lala_1002":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_1.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_1001.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Lala_1002.name);
				break;
			case "Danone_4":
			case "Danone_4001":
			case "Danone_4002":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_4.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_4001.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_4002.name);
				break;
			case "Danone_1":
			case "Danone_1002":
			case "Danone_1001":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_1.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_1002.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Danone_1001.name);
				break;
			case "Activia_2":
			case "Activia_2002":
			case "Activia_2001":
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Activia_2.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Activia_2002.name);
				this.mouseEvents.objectsToValue = this.mouseEvents.objectsToValue.filter((object) => object.name !== this.oxxo.Activia_2001.name);
				break;

			default:
				break;
		}
	}

	onAnimateToPosition(productcliked, positionName) {
		this.evaluatePoints(productcliked, positionName);
		this.onRemoveForClicked(productcliked);
		switch (positionName) {
			case "circle_yogbreak":
				this.pointsactivity.circle_yogbreak.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.956, y: 1.278, z: -0.342 },
					{ x: -0.956, y: 1.278, z: -0.26 },
					{ x: -0.956, y: 1.278, z: -0.183 }
				);
				break;
			case "circle_yoglalafre_pla":
				this.pointsactivity.circle_yoglalafre_pla.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.839, y: 1.293, z: -0.342 },
					{ x: -0.839, y: 1.293, z: -0.26 },
					{ x: -0.839, y: 1.293, z: -0.182 }
				);
				break;
			case "circle_lalafresa":
				this.pointsactivity.circle_lalafresa.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.781, y: 1.293, z: -0.342 },
					{ x: -0.781, y: 1.293, z: -0.26 },
					{ x: -0.781, y: 1.293, z: -0.182 }
				);
				break;
			case "circle_yoplaitnuezfresa":
				this.pointsactivity.circle_yoplaitnuezfresa.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.72, y: 1.293, z: -0.342 },
					{ x: -0.72, y: 1.293, z: -0.26 },
					{ x: -0.72, y: 1.293, z: -0.182 }
				);
				break;
			case "circle_licuadofresaplatano":
				this.pointsactivity.circle_licuadofresaplatano.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.411, y: 1.306, z: -0.342 },
					{ x: -0.411, y: 1.306, z: -0.26 },
					{ x: -0.411, y: 1.306, z: -0.182 }
				);
				break;
			case "circle_activia_ciruela":
				this.pointsactivity.circle_activia_ciruela.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -1.008, y: 1.007, z: -0.342 },
					{ x: -1.008, y: 1.007, z: -0.261 },
					{ x: -1.008, y: 1.007, z: -0.183 }
				);
				break;
			case "circle_danonefresa":
				this.pointsactivity.circle_danonefresa.position.y += 50;
				this.oxxo.animateToFinalPosition(
					productcliked,
					{ x: -0.901, y: 1.027, z: -0.342 },
					{ x: -0.901, y: 1.027, z: -0.261 },
					{ x: -0.901, y: 1.027, z: -0.183 }
				);
				break;

			default:
				break;
		}
	}

	mouseListenersActivityOne() {
		let productcliked;
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				if (productcliked && interactions[0].object.name.includes("circle")) {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoLugar)
					this.pointsactivity.visible = false;
					this.onAnimateToPosition(productcliked, interactions[0].object.name);
					productcliked = null;
				} else if (!interactions[0].object.name.includes("circle")) {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoObjeto)
					this.pointsactivity.visible = true;
					if (productcliked) {
						this.oxxo.onSelectProductFeedback(productcliked.name, 0.922);
					}
					this.oxxo.onSelectProductFeedback(interactions[0].object.name, 1.12);
					productcliked = interactions[0].object;
				}
			}
		});
	}

	renderAnimations(delta) { }
}
